import { useContext } from "react";
import { StoreContext } from "../contexts/Store";

export const useStoreContext = () => {
  return useContext(StoreContext);
};
